import React from 'react'
import { getAuthorName, getAuthorUrl } from '@uswitch/ev-utils/contentful'
import { path } from '@uswitch/ev-utils/obj'

import ArticleSchema from './article-schema'

import { useDataSelector, useIncludes } from '@uswitch/ev-utils/context/selectors'

const createAuthorObject = (fields, orgName, author, origin) => {
  const name = getAuthorName(author) || orgName
  const url = getAuthorUrl(author)
  const type = name === orgName ? 'Organization' : 'Person'

  const authorObject = { '@type': type, name }
  if (url && origin) {
    authorObject.url = `${origin}${url}`
  }

  return authorObject
}

const createImageObject = fields => {
  const file = path(['metaImage', 'fields', 'file'], fields)
  if (!file) return {}

  return {
    '@type': 'ImageObject',
    url: file.url,
    width: path(['details', 'image', 'width'], file, ''),
    height: path(['details', 'image', 'height'], file, ''),
  }
}

const ArticleSchemaConnected = ({ page, meta, url }) => {
  const includes = useIncludes()
  const origin = useDataSelector(['location', 'origin'])

  // if page does not have article schema, return empty props
  if (!page.articleSchema) return null

  const { authors = [], publishDate, updatedDate } = url
  const author = includes[authors?.[0]?.sys.id]
  const publisherName = path(['articleSchema', 'publisher', 'name'], meta, meta.brand)

  const props = {
    context: 'http://schema.org',
    type: 'Article',
    headline: page.title,
    description: page.metaDescription,
    image: createImageObject(page),
    datePublished: publishDate || page.publishedAt || page.sys.createdAt,
    dateModified: updatedDate || page.sys.updatedAt,
    author: createAuthorObject(page, meta.brand, author, origin),
    publisher: {
      '@type': 'Organization',
      name: publisherName,
      logo: {
        '@type': 'ImageObject',
        url: meta.favicon.href,
        width: '48',
        height: '48',
      },
    },
    mainEntityOfPage: { '@type': 'WebPage', '@id': url.href },
  }

  return <ArticleSchema {...props} />
}

export default ArticleSchemaConnected
